import React from "react";
import { Helmet } from "react-helmet";
import "./LegalPages.css";

export const CookiePolicy = () => {
  return (
    <>
      <Helmet>
        <title>Cookie Policy - WTFHoroscope</title>
        <meta name="description" content="Cookie Policy for WTFHoroscope. Information about how we use cookies and storage." />
        <meta name="robots" content="index, follow" />
        <canonical href="https://wtfhoroscope.com/cookie-policy" />
      </Helmet>

      <div className="legal-page">
        <div className="container">
          <h1 className="legal-title">Cookie Policy</h1>

          <section className="legal-section">
            <h2>What are Cookies?</h2>
            <p>
              Cookies are small text files stored on your device when you visit a website. They
              help websites remember things about you and provide a better experience.
            </p>
          </section>

          <section className="legal-section">
            <h2>Our Cookie Usage</h2>
            <p>
              <strong>We don't use cookies for tracking or advertising.</strong> We use browser
              localStorage instead, which works similarly but is more secure.
            </p>
          </section>

          <section className="legal-section">
            <h2>localStorage: Same-Day Caching</h2>
            <p>
              We use browser localStorage to cache your horoscope predictions for the same day. This
              means:
            </p>
            <ul>
              <li>If you generate a horoscope for today, we store it locally in your browser</li>
              <li>
                If you refresh the page, we load your previous prediction without hitting the API
                again
              </li>
              <li>The cache expires at midnight (new day = new cache)</li>
              <li>No data is sent to our servers</li>
            </ul>
            <p>
              This is purely for user convenience and to be nice to our API rate limits. You can
              clear your browser's local storage anytime.
            </p>
          </section>

          <section className="legal-section">
            <h2>Third-Party Advertising Cookies</h2>
            <p>
              WTFHoroscope displays ads from third-party networks including Google AdSense and other
              ad partners. These networks may use cookies and similar technologies to:
            </p>
            <ul>
              <li>Track your browsing behavior</li>
              <li>Display targeted ads</li>
              <li>Measure ad performance</li>
            </ul>
            <p>
              <strong>We do not control these cookies.</strong> You can:
            </p>
            <ul>
              <li>Disable personalized ads in your Google account settings</li>
              <li>Use browser extensions to block cookies</li>
              <li>Adjust your browser privacy settings</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>Essential vs Non-Essential</h2>
            <h3>Essential (No Consent Needed)</h3>
            <ul>
              <li>localStorage for prediction caching</li>
            </ul>

            <h3>Non-Essential (Third-Party Ads)</h3>
            <ul>
              <li>Advertising network cookies - used for targeted ads</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>How to Manage Cookies</h2>
            <p>Most browsers allow you to:</p>
            <ul>
              <li>Block all cookies</li>
              <li>Block third-party cookies</li>
              <li>Clear cookies when you close the browser</li>
              <li>Clear existing cookies</li>
              <li>Set specific cookie preferences</li>
            </ul>
            <p>Check your browser's Help section for instructions.</p>
          </section>

          <section className="legal-section">
            <h2>Google Analytics?</h2>
            <p>
              <strong>We don't use Google Analytics.</strong> We don't track individual user behavior
              across pages. We're just here to give you funny horoscopes.
            </p>
          </section>

          <section className="legal-section">
            <h2>Contact Us</h2>
            <p>
              Questions about our cookie usage? Email:{" "}
              <a href="mailto:privacy@wtfhoroscope.com">privacy@wtfhoroscope.com</a>
            </p>
          </section>

          <section className="legal-section">
            <h2>Last Updated</h2>
            <p>{new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}</p>
          </section>
        </div>
      </div>
    </>
  );
};
